export default "__VITE_ASSET__DyXdjFIZ__"